import SharedBufferGeometry from "./sharedbuffergeometry";
var SharedBufferGeometryManager = /** @class */ (function () {
    function SharedBufferGeometryManager() {
    }
    SharedBufferGeometryManager.addSharedBuffer = function (name, material) {
        var bufferGeometry = new SharedBufferGeometry(material);
        this.sharedBuffers[name] = bufferGeometry;
    };
    SharedBufferGeometryManager.getSharedBuffer = function (name) {
        return this.sharedBuffers[name];
    };
    SharedBufferGeometryManager.sharedBuffers = {};
    return SharedBufferGeometryManager;
}());
export default SharedBufferGeometryManager;
